<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    class="rank-icon"
    style="display:inline-block;vertical-align:middle;flex-shrink:0"
  >
    <title>{{ label }}</title>

    <!-- Start: fundo cinza + estrela branca -->
    <template v-if="normalizedType === 'start'">
      <circle cx="12" cy="12" r="11" fill="#9E9E9E"/>
      <polygon
        points="12,4.5 13.8,9.5 19.2,9.9 15.2,13.4 16.5,18.8 12,15.9 7.5,18.8 8.8,13.4 4.8,9.9 10.2,9.5"
        fill="white"
        fill-opacity="0.9"
        stroke="white"
        stroke-width="0.3"
        stroke-linejoin="round"
      />
    </template>

    <!-- Bronze: fundo bronze + escudo branco -->
    <template v-else-if="normalizedType === 'bronze'">
      <circle cx="12" cy="12" r="11" fill="#CD7F32"/>
      <path
        d="M12 5L7 7.2v4.4c0 3.8 2.2 7.2 5 8.4 2.8-1.2 5-4.6 5-8.4V7.2L12 5z"
        fill="white"
        fill-opacity="0.9"
        stroke="white"
        stroke-width="0.3"
        stroke-linejoin="round"
      />
      <path
        d="M12 8.5l1 2.2h2.3l-1.8 1.5 0.7 2.3L12 13.2l-2.2 1.3 0.7-2.3L8.7 10.7H11z"
        fill="#CD7F32"
        stroke="none"
      />
    </template>

    <!-- Prata: fundo cinza-azulado + escudo branco -->
    <template v-else-if="normalizedType === 'prata'">
      <circle cx="12" cy="12" r="11" fill="#78909C"/>
      <path
        d="M12 5L7 7.2v4.4c0 3.8 2.2 7.2 5 8.4 2.8-1.2 5-4.6 5-8.4V7.2L12 5z"
        fill="white"
        fill-opacity="0.9"
        stroke="white"
        stroke-width="0.3"
        stroke-linejoin="round"
      />
      <path
        d="M12 8.5l1 2.2h2.3l-1.8 1.5 0.7 2.3L12 13.2l-2.2 1.3 0.7-2.3L8.7 10.7H11z"
        fill="#78909C"
        stroke="none"
      />
    </template>

    <!-- Ouro: fundo âmbar + escudo + coroa brancos -->
    <template v-else-if="normalizedType === 'ouro'">
      <circle cx="12" cy="12" r="11" fill="#FFB300"/>
      <path
        d="M12 5L7 7.2v4.4c0 3.8 2.2 7.2 5 8.4 2.8-1.2 5-4.6 5-8.4V7.2L12 5z"
        fill="white"
        fill-opacity="0.9"
        stroke="white"
        stroke-width="0.3"
        stroke-linejoin="round"
      />
      <!-- coroa interna -->
      <path
        d="M9.2 13.8h5.6V14.8H9.2zM9.2 13.8l1-2.8 1.8 1.6 1-2.6 1 2.6 1.8-1.6 1 2.8"
        fill="#FFB300"
        stroke="none"
      />
    </template>

    <!-- Diamante: fundo azul + gema branca com facetas -->
    <template v-else-if="normalizedType === 'diamante'">
      <circle cx="12" cy="12" r="11" fill="#29B6F6"/>
      <!-- gema -->
      <polygon
        points="12,4.5 19.5,10.5 12,20 4.5,10.5"
        fill="white"
        fill-opacity="0.9"
        stroke="white"
        stroke-width="0.3"
        stroke-linejoin="round"
      />
      <!-- facetas internas azuis -->
      <line x1="4.5"  y1="10.5" x2="19.5" y2="10.5" stroke="#29B6F6" stroke-width="0.8"/>
      <line x1="12"   y1="4.5"  x2="12"   y2="10.5" stroke="#29B6F6" stroke-width="0.6" stroke-opacity="0.6"/>
      <line x1="8"    y1="10.5" x2="12"   y2="20"   stroke="#29B6F6" stroke-width="0.6" stroke-opacity="0.5"/>
      <line x1="16"   y1="10.5" x2="12"   y2="20"   stroke="#29B6F6" stroke-width="0.6" stroke-opacity="0.5"/>
    </template>

    <!-- Fallback -->
    <template v-else>
      <circle cx="12" cy="12" r="11" fill="#CCCCCC"/>
    </template>
  </svg>
</template>

<script>
const TYPE_CONFIG = {
  start:    { label: 'Start' },
  bronze:   { label: 'Bronze' },
  prata:    { label: 'Prata' },
  ouro:     { label: 'Ouro' },
  diamante: { label: 'Diamante' },
};

export default {
  name: 'RankIcon',

  props: {
    type: {
      type: String,
      default: '',
    },
    size: {
      type: [Number, String],
      default: 20,
    },
  },

  computed: {
    normalizedType() {
      return (this.type || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
    label() {
      const config = TYPE_CONFIG[this.normalizedType];
      return config ? config.label : (this.type || '');
    },
  },
};
</script>
